export const DepartmentActionTypes = {
  FETCH_DEPARTMENTS_START: "FETCH_DEPARTMENTS_START_NEW",
  SET_ALL_DEPARTMENTS: "SET_ALL_DEPARTMENTS_NEW",
  FETCH_DEPARTMENTS_SUCCESS: "FETCH_DEPARTMENTS_SUCCESS_NEW",
  FETCH_DEPARTMENTS_FAILURE: "FETCH_DEPARTMENTS_FAILURE_NEW",
  SET_DEPARTMENTS_ON_PAGE: "SET_DEPARTMENTS_ON_PAGE_NEW",
  SET_SEARCH_DEPARTMENTS_QUERY: "SET_SEARCH_DEPARTMENTS_QUERY_NEW",
  ADD_SELECTED_DEPARTMENT: "ADD_SELECTED_DEPARTMENT_NEW",
  DELETE_SELECTED_DEPARTMENT: "DELETE_SELECTED_DEPARTMENT_NEW",
  SET_SELECTED_DEPARTMENT: "SET_SELECTED_DEPARTMENT_NEW",
};
